import type { HTMLAttributes, ReactNode } from "react";
import styles from "./LineTablist.module.css";
import { cx } from "../cx";

export type LineTab<K extends string = string> = { key: K; label: ReactNode };

export type LineTablistProps<K extends string = string> = Omit<HTMLAttributes<HTMLDivElement>, "onChange"> & {
  items: readonly LineTab<K>[];
  value: K;
  onChange: (key: K) => void;
};

/** 밑줄 탭 (Figma 122:6545 · 194:10824). 전폭 균등 분할, 라벨 t5(선택 Bold fg-neutral / 비선택 Regular subtle), 선택 밑줄 2px, 하단 1px stroke-neutral-muted. */
export function LineTablist<K extends string>({ items, value, onChange, className, ...rest }: LineTablistProps<K>) {
  return (
    <div role="tablist" className={cx(styles.root, className)} {...rest}>
      {items.map((item) => {
        const selected = item.key === value;
        return (
          <button key={item.key} type="button" role="tab" aria-selected={selected} className={cx(styles.tab, selected && styles.selected)} onClick={() => onChange(item.key)}>
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
